export default class User {
  constructor(data) {
    if(!data) {
      data = {};
    }
    this._id = data._id;
    this.username = data.username;
    this.password = data.password;
    this.salt = data.salt;
    this.email = data.email;
    this.firstname = data.firstname;
    this.lastname = data.lastname;
  }
}
